/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Swal_ConfirmInputs */

const en_merge_swal_confirm = /** @type {(inputs: Merge_Swal_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const fr_merge_swal_confirm = /** @type {(inputs: Merge_Swal_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui`)
};

const de_merge_swal_confirm = /** @type {(inputs: Merge_Swal_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const it_merge_swal_confirm = /** @type {(inputs: Merge_Swal_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SÌ`)
};

const ru_merge_swal_confirm = /** @type {(inputs: Merge_Swal_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да`)
};

const es_merge_swal_confirm = /** @type {(inputs: Merge_Swal_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí`)
};

const zh_cn2_merge_swal_confirm = /** @type {(inputs: Merge_Swal_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的`)
};

const ja_merge_swal_confirm = /** @type {(inputs: Merge_Swal_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい`)
};

const hi_merge_swal_confirm = /** @type {(inputs: Merge_Swal_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हाँ`)
};

const pt_pt2_merge_swal_confirm = /** @type {(inputs: Merge_Swal_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim`)
};

/**
* | output |
* | --- |
* | "Yes" |
*
* @param {Merge_Swal_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_swal_confirm = /** @type {((inputs?: Merge_Swal_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Swal_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_merge_swal_confirm(inputs)
	if (locale === "de") return de_merge_swal_confirm(inputs)
	if (locale === "it") return it_merge_swal_confirm(inputs)
	if (locale === "ru") return ru_merge_swal_confirm(inputs)
	if (locale === "es") return es_merge_swal_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_merge_swal_confirm(inputs)
	if (locale === "ja") return ja_merge_swal_confirm(inputs)
	if (locale === "hi") return hi_merge_swal_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_merge_swal_confirm(inputs)
	return en_merge_swal_confirm(inputs)
});